// src/components/PortfolioItem.jsx
import React from "react";
import { FaArrowRight } from "react-icons/fa";

const PortfolioItem = ({ project }) => {
  return (
    <div
      className="portfolio-box-items wow fadeInUp"
      data-wow-delay=".3s"
    >
      <div className="project-wrap">
        <div className="content">
          <span>{project.category}</span>
          <h3>
            <a href={project.link}>
              {project.title.split("<br />").map((line, i) => (
                <React.Fragment key={i}>
                  {line.trim()}
                  <br />
                </React.Fragment>
              ))}
            </a>
          </h3>
        </div>
        <p>{project.desc}</p>
      </div>
      <a
        href={project.link}
        className="radius-btn"
      >
        <FaArrowRight /> View Details
      </a>
      <div
        className="project-hover d-none d-md-block bg-cover"
        style={{
          backgroundImage: `url(${project.img})`,
        }}
      />
    </div>
  );
};

export default PortfolioItem;
